module.exports = __webpack_public_path__ + "static/img/banner1.9f90121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/banner1.png
// module id = DF8t
// module chunks = 0